import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

/** Subtitle row: icon + text (members count or position). Larger than BaseCard stat for readability. */
export const GROUP_CARD_SUBTITLE_ICON_SIZE = 20
const SUBTITLE_FONT_SIZE = 15
/** Gold (design --zp-accent) for the trophy rank + creator badge, matching the approved design. */
export const GROUP_CARD_RANK_GOLD = '#FCD34D'

/** Creator badge: small gamified pill (icon + label) shown when the current user created the group. Uses theme primary. */
export const getGroupCardStyles = (theme: Theme) =>
  StyleSheet.create({
    subtitleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
    },
    subtitleIcon: {
      opacity: 1,
    },
    subtitleText: {
      fontSize: SUBTITLE_FONT_SIZE,
      color: theme.gray[600],
      fontWeight: '500',
    },
    /** Rank number rendered in gold beside the trophy (design). */
    subtitleRankText: {
      color: GROUP_CARD_RANK_GOLD,
      fontWeight: '700',
    },
    /** Separator between members count and position on the same row. */
    subtitleSeparator: {
      fontSize: SUBTITLE_FONT_SIZE,
      color: theme.gray[500],
      marginHorizontal: 6,
    },
    // Design: gold pill with dark text/icon, top-left of the group cover.
    creatorBadge: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      backgroundColor: GROUP_CARD_RANK_GOLD,
      paddingHorizontal: 8,
      paddingVertical: 4,
      borderRadius: 9999,
      shadowColor: GROUP_CARD_RANK_GOLD,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.35,
      shadowRadius: 6,
      elevation: 2,
    },
    creatorBadgeIcon: {
      opacity: 1,
    },
    creatorBadgeText: {
      fontSize: 11,
      fontWeight: '700',
      color: '#1A202C',
      letterSpacing: 0.2,
    },
  })
